import React, { useState } from 'react';
import styles from './ContactForm.module.css';
const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: '',
    });
    const [status, setStatus] = useState('idle');
    const [errorMessage, setErrorMessage] = useState('');
    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('submitting');
        setErrorMessage('');
        try {
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {
                setStatus('success');
                setFormData({ name: '', email: '', message: '' });
            }
            else {
                const data = await response.json();
                setErrorMessage(data.error || 'Something went wrong. Please try again.');
                setStatus('error');
            }
        }
        catch (error) {
            setErrorMessage('Network error. Please check your connection and try again.');
            setStatus('error');
        }
    };
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };
    if (status === 'success') {
        return (React.createElement("div", { className: styles.successMessage },
            React.createElement("h3", null, "Message Sent!"),
            React.createElement("p", null, "Thank you for reaching out. I'll get back to you within 24 hours."),
            React.createElement("button", { onClick: () => setStatus('idle'), className: styles.resetButton }, "Send Another Message")));
    }
    return (React.createElement("form", { onSubmit: handleSubmit, className: styles.form },
        React.createElement("div", { className: styles.formGroup },
            React.createElement("label", { htmlFor: "name" }, "Name"),
            React.createElement("input", { type: "text", id: "name", name: "name", value: formData.name, onChange: handleChange, required: true, disabled: status === 'submitting', className: styles.input })),
        React.createElement("div", { className: styles.formGroup },
            React.createElement("label", { htmlFor: "email" }, "Email"),
            React.createElement("input", { type: "email", id: "email", name: "email", value: formData.email, onChange: handleChange, required: true, disabled: status === 'submitting', className: styles.input })),
        React.createElement("div", { className: styles.formGroup },
            React.createElement("label", { htmlFor: "message" }, "Message"),
            React.createElement("textarea", { id: "message", name: "message", value: formData.message, onChange: handleChange, required: true, disabled: status === 'submitting', rows: 6, className: styles.textarea, placeholder: "Tell me about your program, challenges, or what you're trying to accomplish..." })),
        status === 'error' && (React.createElement("div", { className: styles.errorMessage }, errorMessage)),
        React.createElement("button", { type: "submit", disabled: status === 'submitting', className: styles.submitButton }, status === 'submitting' ? 'Sending...' : 'Send Message'),
        React.createElement("p", { className: styles.alternative },
            "Prefer email? Reach out directly at ",
            React.createElement("a", { href: "mailto:hello@wolfeyeconsulting.com" }, "hello@wolfeyeconsulting.com"))));
};
export default ContactForm;
